export const colors = {
    black:        "#191718",
    greyDark:     "#4f4e50",
    grey:         "#848487",
    greyLight:    "#bababf",
    pale:         "#ecebeb",
    blueLight:    "#6C97F1",
    blueMidLight: "#3E64C8",
    blue:         "#2d3291",
    blueDark:     "#222951",
    green:        "#00a550",
    greenDark:    "#0d5e34",
    red:          "#f01e23",
    redDark:      "#851b1e",
    orange:       "#df5f1f",
    primary:      "#2d3291",
    secondary:    "#848487",
    success:      "#00a550",
    info:         "#2d3291",
    warning:      "#df5f1f",
    danger:       "#851b1e",
    light:        "#ffffff",
    dark:         "#4f4e50",
    indigo:       "#6610f2",
    purple:       "#6f42c1",
    pinkLight:    "#feb4b4",
    pink:         "#f67198",
    yellow:       "#ffc107",
    teal:         "#20c997",
    cyan:         "#17a2b8",
}